<div class="scroll-table">
  <p-listbox
    [options]="dataBskFilters"
    [(ngModel)]="idRequest"
    (onChange)="onClickFilter($event)"
    [filter]="true"
    optionLabel="label"
    [listStyle]="{ width: '100%' }"
    [scrollHeight]="height"
    >
    <ng-template let-request pTemplate="item">
      <div class="flex align-items-center">  
        @switch (request.visibility) {
          @case (0) {
            <i class="icons8-search margin-right iconstyle"></i>
          }
          @case (1) {
            <i class="icons8-user-groups margin-right iconstyle"></i>
          }
          @case (2) {
            <i class="icons8-user margin-right iconstyle"></i>
          }
          @case (3) {
            <i class="icons8-haute-priorit- margin-right iconstyle"></i>
          }
        }
        <div class="margin-left">
          <span class="title">
            {{ request.label }}
          </span>
          <div>
            {{ request.description }}
          </div>
        </div>
      </div>
    </ng-template>
  </p-listbox>
</div>
